'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set2 = require('./internal/_set');

var _set3 = _interopRequireDefault(_set2);

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a copy of `subject` with `key` set to `value`.
 *
 * @example
 * set('one', 2, {one: 1});
 * // returns {one: 2}
 *
 * @param {any} key
 * @param {any} value
 * @param {Array|Iterable|Object} subject
 * @return {Array|Iterable|Object}
 */
exports.default = (0, _curry2.default)(_set3.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.9/set.js
// module id = 192
// module chunks = 2 3